(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zoh-home-hero"] && !Shopify.designMode) return;
  try {
    
if (!window.zohHomeTracking) {
 window.zohHomeTracking = true;
 document.addEventListener('click', function(event) {
  const link = event.target.closest('a[data-zoh-promotion],a[data-zoh-banner]');
  if (!link || window.Shopify?.designMode) return;
  const privacy = window.Shopify?.customerPrivacy;
  if (!privacy || !privacy.analyticsProcessingAllowed()) return;
  const promotion = {promotion_id:link.dataset.zohPromotion || link.dataset.zohBanner,promotion_name:link.textContent.trim(),creative_slot:link.dataset.zohPosition || "homepage",link_url:link.href};
  if (typeof window.gtag === 'function') window.gtag('event','select_promotion',promotion);
  if (window.Shopify?.analytics?.publish) window.Shopify.analytics.publish('zoh_home_promotion_click',promotion);
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoh-kefir-reference"] && !Shopify.designMode) return;
  try {
    
function initKefirPage(){
 const root=document.querySelector('[data-kefir-page]');if(!root||root.dataset.ready)return;root.dataset.ready='true';
 const quantity=root.querySelector('input[name="quantity"]');root.querySelectorAll('[data-quantity]').forEach(button=>button.addEventListener('click',()=>{quantity.value=Math.max(1,(parseInt(quantity.value,10)||1)+Number(button.dataset.quantity));quantity.dispatchEvent(new Event('change',{bubbles:true}));}));
 const select=root.querySelector('[data-reculture]'),calc=root.querySelector('[data-pack-price]');select?.addEventListener('change',()=>{const litres=5*(1+Number(select.value));calc.querySelector('[data-litres]').textContent=litres;calc.querySelector('[data-litre-cost]').textContent=new Intl.NumberFormat(document.documentElement.lang||'en-IN',{style:'currency',currency:calc.dataset.currency||'INR',maximumFractionDigits:2}).format(Number(calc.dataset.packPrice)/100/litres);});
 const climate=root.querySelector('[data-climate-select]');climate?.addEventListener('change',()=>{root.querySelectorAll('[data-climate]').forEach(panel=>panel.hidden=panel.dataset.climate!==climate.value);});
 const sticky=root.querySelector('[data-sticky-buy]'),buy=root.querySelector('.zk6-form');if('IntersectionObserver'in window&&sticky&&buy){let reached=false;new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting)reached=true;sticky.hidden=entry.isIntersecting||!reached;}},{threshold:0}).observe(buy);}
 root.querySelectorAll('details').forEach(el=>el.addEventListener('toggle',()=>{if(el.open&&Array.isArray(window.dataLayer))window.dataLayer.push({event:'kefir_faq_open',question:el.querySelector('summary')?.textContent.trim()});}));
}
initKefirPage();document.addEventListener('shopify:section:load',initKefirPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoh-koji"] && !Shopify.designMode) return;
  try {
    

function initKoji(){document.querySelectorAll('[data-koji-page]').forEach(root=>{if(root.dataset.initialized)return;root.dataset.initialized='true';root.querySelectorAll('.zk-packs input').forEach(input=>input.addEventListener('change',()=>{root.querySelector('[data-koji-price]').textContent=input.dataset.price;root.querySelector('[data-koji-sticky-price]').textContent=input.dataset.price;const compare=root.querySelector('[data-koji-compare]');compare.textContent=input.dataset.compare;compare.hidden=!input.dataset.compare;const url=new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState({},'',url)}));root.querySelectorAll('[data-koji-filter]').forEach(btn=>btn.addEventListener('click',()=>{root.querySelectorAll('[data-koji-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===btn)));const selected=btn.dataset.kojiFilter;root.querySelectorAll('[data-koji-tags]').forEach(card=>{card.hidden=selected!=='all'&&!card.dataset.kojiTags.split(' ').includes(selected)});root.querySelector('.zk-recipes').scrollLeft=0;if(selected==='advanced'){root.querySelector('.zk-advanced-grid').classList.add('zk-highlight')}else{root.querySelector('.zk-advanced-grid').classList.remove('zk-highlight')}}));const sticky=root.querySelector('[data-koji-sticky]');if('IntersectionObserver'in window){new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||window.scrollY<300},{threshold:0}).observe(root.querySelector('.zk-product-form'))}})}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initKoji)}else{initKoji()}document.addEventListener('shopify:section:load',initKoji);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoh-kombucha-visual"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = root => {
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const params = new URLSearchParams(window.location.search);
  root.querySelectorAll('[data-brew-link]').forEach(link => {
   const url = new URL(link.href, window.location.origin);
   if (params.has('preview_theme_id')) url.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
   if (params.get('view') === 'kombucha-visual') url.searchParams.set('view', 'kombucha-visual');
   link.href = url.toString();
  });
  const dialog = root.querySelector('dialog');
  root.querySelectorAll('[data-photo-url]').forEach(button => button.addEventListener('click', () => {
   const photo = dialog.querySelector('img');
   photo.src = button.dataset.photoUrl;
   photo.alt = button.dataset.photoAlt || '';
   dialog.showModal();
  }));
  dialog.querySelector('[data-close-photo]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  const sticky = root.querySelector('[data-brew-sticky]');
  const form = root.querySelector('.zb-form');
  if ('IntersectionObserver' in window) {
   new IntersectionObserver(entries => {
    sticky.hidden = entries[0].isIntersecting;
   }, { threshold: 0 }).observe(form);
  }
 };
 document.querySelectorAll('[data-brew-page]').forEach(init);
 document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-brew-page]')));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoh-natto"] && !Shopify.designMode) return;
  try {
    
function initNatto(root){if(!root||root.dataset.initialized)return;root.dataset.initialized='true';const sticky=root.querySelector('.zn-sticky');const buy=root.querySelector('.zn-buy');if('IntersectionObserver' in window){new IntersectionObserver(([entry])=>{sticky.hidden=entry.isIntersecting||window.scrollY<400}).observe(buy);}}
document.querySelectorAll('[data-natto-page]').forEach(initNatto);
document.addEventListener('shopify:section:load',e=>initNatto(e.target.querySelector('[data-natto-page]')));

document.querySelectorAll('[data-natto-recipe]').forEach(link=>link.addEventListener('click',e=>{const dialog=document.getElementById(link.dataset.nattoRecipe);if(dialog&&typeof dialog.showModal==='function'){e.preventDefault();dialog.showModal();}}));
document.querySelectorAll('.zn-recipe-dialog').forEach(dialog=>dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoh-sourdough"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=root=>{if(!root||root.dataset.ready)return;root.dataset.ready='true';const hero=root.querySelector('.zs-main-photo img');root.querySelectorAll('[data-photo]').forEach(b=>b.addEventListener('click',()=>{hero.removeAttribute('srcset');hero.src=b.dataset.photo;hero.alt=b.dataset.alt||''}));const sticky=root.querySelector('.zs-sticky'),buy=root.querySelector('.zs-purchase');if('IntersectionObserver'in window)new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||window.scrollY<300}).observe(buy)};document.querySelectorAll('[data-sourdough-page]').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('[data-sourdough-page]')));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoh-water-kefir"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=root=>{if(!root||root.dataset.ready)return;root.dataset.ready='true';const hero=root.querySelector('.zw-main-photo img');root.querySelectorAll('[data-photo]').forEach(b=>b.addEventListener('click',()=>{hero.removeAttribute('srcset');hero.src=b.dataset.photo;hero.alt=b.dataset.alt||''}));const sticky=root.querySelector('.zw-sticky'),buy=root.querySelector('.zw-purchase');if('IntersectionObserver'in window)new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||window.scrollY<300}).observe(buy)};document.querySelectorAll('[data-water-page]').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('[data-water-page]')));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoh-yogurt"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=root=>{if(!root||root.dataset.ready)return;root.dataset.ready='true';const hero=root.querySelector('.zy-hero-photo img');root.querySelectorAll('[data-photo]').forEach(b=>b.addEventListener('click',()=>{hero.removeAttribute('srcset');hero.src=b.dataset.photo;hero.alt=b.dataset.alt||'';root.querySelectorAll('[data-photo]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)))}));const sticky=root.querySelector('.zy-sticky');const buy=root.querySelector('.zy-purchase');let queued=false;const update=()=>{queued=false;sticky.hidden=buy.getBoundingClientRect().bottom>0};const queue=()=>{if(!queued){queued=true;requestAnimationFrame(update)}};window.addEventListener('scroll',queue,{passive:true});window.addEventListener('resize',queue);if('ResizeObserver'in window)new ResizeObserver(queue).observe(root);update();root.querySelectorAll('[data-yogurt-alternate]').forEach(a=>{const q=new URLSearchParams(location.search);if(q.has('preview_theme_id')){const u=new URL(a.href);u.searchParams.set('preview_theme_id',q.get('preview_theme_id'));a.href=u.toString()}})};document.querySelectorAll('[data-yogurt]').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('[data-yogurt]')));})();

  } catch(e) { console.error(e); }
})();
})();
